import React from 'react';
import AFilterForm from '../../components/AFilterForm/AFilterForm';
import { getFilterFormFields } from './utils';
import { EMPTY_FILTER_FORM } from './constants';
import AButton from '../../views/pages/manage/common/form-fields-mui/AButton';

const Filters = ({
    filterForm,
    handleFilterForm,
    getBulkTransferRequestsList,
    paymentModeDropdown
}) => {

    const searchHandler = (filters = {}) => {
        getBulkTransferRequestsList({
            filters: { ...filterForm, ...filters },
            pageNo: 0
        })
    }
    

    return (
        <AFilterForm
            formFields={getFilterFormFields(paymentModeDropdown,filterForm)}
            filterForm={filterForm}
            handleFilterForm={handleFilterForm}
            applyFilterHandler={searchHandler}
            removeFilterHandler={() => searchHandler(EMPTY_FILTER_FORM)}
            btnComponent={
                <AButton
                    variant='outline'
                    outlineVariantColor={"#bfbfbf"}
                    textColor={"#000"}
                    size='xs'
                >
                    Filters
                </AButton>
            }
        />
    );
}

export default Filters;